<ng-container *ngIf="(account$ | async) as account">

  <p-table 
    #contactsTable 
    [value]="account.data.contacts" 
    [globalFilterFields]="['name']"
    styleClass="mt-5 p-datatable-striped" 
    dataKey="_meta.id" 
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="contactsTable.filterGlobal($any($event).target.value, 'contains')" placeholder="Search keyword" />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-contact>
      <tr [pSelectableRow]="contact">
        <td class="contact-text">{{ contact.name }}</td>
        <td class="contact-actions">
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onEditContact($event, contact)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="!contact.disabled" pButton pRipple type="button" icon="pi pi-trash" (click)="onDeleteContact($event, contact)" class="p-button-rounded p-button-danger p-button-text"></button>
          <button *ngIf="contact.disabled" pButton pRipple type="button" icon="pi pi-refresh" (click)="onRestoreContact($event, contact)" class="p-button-rounded p-button-success p-button-text"></button>
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>